import api from "../../../api"

export const responsesApi = (payload) => {
    return api.post("responses?category=next_form", payload);
}

export const transactionApi = (payload, transactionId) => {
    return api.put(`transaction/${transactionId}`, payload);
}